import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { BsLinkedin, BsGithub, BsTwitterX, BsInstagram, BsDiscord } from "react-icons/bs";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane, FaRegClock } from "react-icons/fa";
import { HiOutlineChatAlt2, HiOutlineUser, HiOutlineMail } from "react-icons/hi";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    msg: ""
  });
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, msg } = formData;
    
    if (!name || !email || !msg) {
      toast.error("Please fill in all fields");
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    setLoading(true);
    try {
      const res = await axios.post(
        "https://portfolio-backend-z0dm.onrender.com/contact",
        { name, email, msg }
      );
      if (res.data.message === "Thank You for your message!") {
        toast.success(res.data.message);
        setFormData({ name: "", email: "", msg: "" });
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const socialLinks = [
    { icon: BsLinkedin, href: "http://linkedin.com/in/ayush-rai-7109202b6", color: "#0077b5", label: "LinkedIn", bgColor: "hover:bg-[#0077b5]" },
    { icon: BsGithub, href: "https://github.com/ayush123-bit", color: "#333", label: "GitHub", bgColor: "hover:bg-gray-800 dark:hover:bg-gray-700" },
    { icon: BsTwitterX, href: "https://x.com/AyushRa36652420", color: "#000", label: "Twitter", bgColor: "hover:bg-black" },
    { icon: BsInstagram, href: "https://instagram.com", color: "#E4405F", label: "Instagram", bgColor: "hover:bg-gradient-to-r hover:from-[#833AB4] hover:via-[#E4405F] hover:to-[#F56040]" },
    { icon: BsDiscord, href: "https://discord.com", color: "#5865F2", label: "Discord", bgColor: "hover:bg-[#5865F2]" },
  ];

  const contactInfo = [
    { icon: FaEnvelope, label: "Email", value: "ayushrai803@gmail.com", action: "mailto:ayushrai803@gmail.com", color: "#f29f67" },
    { icon: FaPhone, label: "Phone", value: "+91 8318542040", action: "tel:+918318542040", color: "#3b8ff3" },
    { icon: FaMapMarkerAlt, label: "Location", value: "Varanasi, UP, India", action: null, color: "#10b981" },
    { icon: FaRegClock, label: "Response Time", value: "Within 24 hours", action: null, color: "#8b5cf6" },
  ];

  const inputFields = [
    { name: "name", label: "Your Name", type: "text", placeholder: "John Doe", icon: HiOutlineUser, autoComplete: "name" },
    { name: "email", label: "Email Address", type: "email", placeholder: "john@example.com", icon: HiOutlineMail, autoComplete: "email" },
    { name: "msg", label: "Message", type: "textarea", placeholder: "Tell me about your project or collaboration idea...", icon: HiOutlineChatAlt2, rows: 5 },
  ];

  return (
    <section
      id="contact"
      className="py-20 px-4 bg-gradient-to-br from-blue-50 to-indigo-50
        dark:from-[#0a0a18] dark:to-[#0f0f1a] transition-colors duration-300
        relative overflow-hidden"
    >
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-64 h-64 rounded-full bg-[#f29f67]/5 dark:bg-[#f29f67]/5 blur-3xl" />
        <div className="absolute bottom-20 left-10 w-80 h-80 rounded-full bg-[#3b8ff3]/5 dark:bg-[#3b8ff3]/5 blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header Section */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6
            bg-white/80 dark:bg-white/5 backdrop-blur-sm
            border border-gray-200 dark:border-white/10">
            <span className="text-2xl">💬</span>
            <span className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
              Let's Connect
            </span>
          </div>
          <h2
            className="text-3xl sm:text-4xl font-extrabold uppercase tracking-widest
              text-gray-800 dark:text-white mb-3"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Get In Touch
          </h2>
          <div className="w-20 h-1 mx-auto rounded-full bg-gradient-to-r from-[#f29f67] to-[#3b8ff3] mb-4" />
          <p className="text-gray-600 dark:text-gray-400 text-sm max-w-md mx-auto">
            Have a project in mind or want to collaborate? I'd love to hear from you!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left - Contact Information Panel */}
          <div className="space-y-6">
            {/* Contact Info Cards */}
            <div className="p-6 rounded-2xl 
              bg-white/90 dark:bg-white/5
              backdrop-blur-sm
              border border-gray-200 dark:border-white/10
              hover:shadow-xl transition-all duration-300">
              <h3
                className="text-lg font-bold text-gray-900 dark:text-white mb-5 flex items-center gap-2"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#f29f67] to-[#3b8ff3] 
                  flex items-center justify-center">
                  <FaPaperPlane className="text-white text-sm" />
                </span>
                Contact Information
              </h3>
              
              <div className="space-y-4">
                {contactInfo.map((item, idx) => (
                  <div key={item.label} className="group">
                    {item.action ? (
                      <a
                        href={item.action}
                        className="flex items-center gap-3 p-3 rounded-xl
                          hover:bg-gray-50 dark:hover:bg-white/10
                          transition-all duration-300 cursor-pointer
                          group hover:-translate-y-0.5"
                      >
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#f29f67] to-[#3b8ff3]
                          flex items-center justify-center flex-shrink-0
                          shadow-md group-hover:scale-110 transition-transform">
                          <item.icon className="text-white text-base" />
                        </div>
                        <div className="flex-1">
                          <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            {item.label}
                          </div>
                          <div className="text-sm font-medium text-gray-800 dark:text-gray-200 group-hover:text-[#f29f67] transition-colors">
                            {item.value}
                          </div>
                        </div>
                        <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                          <svg className="w-4 h-4 text-[#f29f67]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </a>
                    ) : (
                      <div className="flex items-center gap-3 p-3 rounded-xl
                        transition-all duration-300">
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#f29f67] to-[#3b8ff3]
                          flex items-center justify-center flex-shrink-0 shadow-md">
                          <item.icon className="text-white text-base" />
                        </div>
                        <div>
                          <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            {item.label}
                          </div>
                          <div className="text-sm font-medium text-gray-800 dark:text-gray-200">
                            {item.value}
                          </div>
                        </div>
                      </div>
                    )}
                    {idx < contactInfo.length - 1 && (
                      <div className="border-b border-gray-100 dark:border-white/8 my-2" />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Social Links with Enhanced Design */}
            <div className="p-6 rounded-2xl 
              bg-white/90 dark:bg-white/5
              backdrop-blur-sm
              border border-gray-200 dark:border-white/10
              hover:shadow-xl transition-all duration-300">
              <h3
                className="text-lg font-bold text-gray-900 dark:text-white mb-5 flex items-center gap-2"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                <span className="text-2xl">🌐</span>
                Connect With Me
              </h3>
              
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`group flex items-center gap-2 px-3 py-2.5 rounded-xl
                      bg-gray-50 dark:bg-white/8 
                      border border-gray-200 dark:border-white/10
                      text-gray-700 dark:text-gray-300
                      ${social.bgColor}
                      transition-all duration-300 hover:-translate-y-1 hover:shadow-lg
                      hover:text-white`}
                    title={social.label}
                  >
                    <social.icon size={16} className="group-hover:scale-110 transition-transform" />
                    <span className="text-xs font-medium">{social.label}</span>
                  </a>
                ))}
              </div>
              
              {/* Availability Note */}
              <div className="mt-5 p-3 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800/30">
                <div className="flex items-center gap-2">
                  <div className="relative">
                    <span className="absolute inline-flex h-2 w-2 rounded-full bg-green-400 opacity-75 animate-ping"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                  </div>
                  <p className="text-xs text-green-700 dark:text-green-400">
                    Available for freelance work and collaborations
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Contact Form */}
          <div className="p-6 sm:p-8 rounded-2xl 
            bg-white/90 dark:bg-white/5
            backdrop-blur-sm
            border border-gray-200 dark:border-white/10
            hover:shadow-xl transition-all duration-300">
            <h3
              className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center gap-2"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              <span className="text-2xl">✉️</span>
              Send a Message
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-5">
              {inputFields.map((field) => (
                <div key={field.name} className="relative group">
                  <label 
                    htmlFor={field.name}
                    className={`block text-xs font-semibold text-gray-600 dark:text-gray-400
                      uppercase tracking-wider mb-2 transition-all duration-200
                      ${focusedField === field.name ? 'text-[#f29f67]' : ''}`}
                  >
                    {field.label}
                  </label>
                  
                  <div className="relative">
                    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500
                      group-hover:text-[#f29f67] transition-colors z-10">
                      <field.icon size={16} />
                    </div>
                    
                    {field.type === "textarea" ? (
                      <textarea
                        id={field.name}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        onFocus={() => setFocusedField(field.name)}
                        onBlur={() => setFocusedField(null)}
                        rows={field.rows}
                        placeholder={field.placeholder}
                        className="w-full px-4 py-3 pl-10 rounded-xl text-sm
                          bg-gray-50 dark:bg-white/8
                          border-2 border-gray-200 dark:border-white/10
                          text-gray-800 dark:text-white
                          placeholder-gray-400 dark:placeholder-gray-500
                          focus:outline-none focus:border-[#f29f67] focus:ring-2 focus:ring-[#f29f67]/20
                          transition-all duration-200 resize-none"
                      />
                    ) : (
                      <input
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        onFocus={() => setFocusedField(field.name)}
                        onBlur={() => setFocusedField(null)}
                        placeholder={field.placeholder}
                        autoComplete={field.autoComplete}
                        className="w-full px-4 py-3 pl-10 rounded-xl text-sm
                          bg-gray-50 dark:bg-white/8
                          border-2 border-gray-200 dark:border-white/10
                          text-gray-800 dark:text-white
                          placeholder-gray-400 dark:placeholder-gray-500
                          focus:outline-none focus:border-[#f29f67] focus:ring-2 focus:ring-[#f29f67]/20
                          transition-all duration-200"
                      />
                    )}
                  </div>
                </div>
              ))}
              
              <button
                type="submit"
                disabled={loading}
                className="group relative w-full py-3.5 rounded-xl font-semibold text-sm text-white
                  bg-gradient-to-r from-[#f29f67] to-[#e08a50]
                  hover:shadow-xl hover:shadow-[#f29f67]/30 hover:-translate-y-0.5
                  disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0
                  transition-all duration-300 overflow-hidden"
              >
                <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-white/0 to-white/20 
                  transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500" />
                
                {loading ? (
                  <div className="flex items-center justify-center gap-2 relative z-10">
                    <ClipLoader color="#fff" size={18} />
                    <span>Sending...</span>
                  </div>
                ) : (
                  <div className="flex items-center justify-center gap-2 relative z-10">
                    <FaPaperPlane size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    <span>Send Message</span>
                  </div>
                )}
              </button>
              
              {/* Form Footer Note */}
              <p className="text-center text-xs text-gray-500 dark:text-gray-400 mt-4">
                I'll get back to you within 24 hours. No spam, promise! ✨
              </p>
            </form>
          </div>
        </div>
        
        {/* Map/Additional Info Section */}
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-white/10">
          <div className="text-center">
            <p className="text-xs text-gray-500 dark:text-gray-400">
              © 2024 Ayush Rai. All rights reserved. | Built with ❤️ using React & Tailwind CSS
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;